import { createContext, useContext } from 'react';
import noop from 'utils/noop';
import {
  queryParamContextDefaults,
  QueryParamContextState,
} from 'modules/templateEditor/context/QueryParamContext';
import { InStudioTemplateProps } from '../InStudioTemplateEditing.types';

export interface InStudioTakeoverContextState
  extends Omit<QueryParamContextState, 'view' | 'templateId' | 'campaignId'>,
    Omit<InStudioTemplateProps, 'onViewChange' | 'onTemplateIdChange' | 'onCampaignIdChange'> {
  isCheckingForUnsavedChanges: boolean;
  setCheckForUnsavedChanges: (val: boolean) => void;
  isSavingDesignChanges: boolean;
  setIsSavingDesignChanges: (val: boolean) => void;
  shouldCloseTakeover: boolean;
  setShouldCloseTakeover: (val: boolean) => void;
}

export const InStudioTakeoverContext = createContext<InStudioTakeoverContextState>({
  ...queryParamContextDefaults,
  isCheckingForUnsavedChanges: false,
  setCheckForUnsavedChanges: noop,
  isSavingDesignChanges: false,
  setIsSavingDesignChanges: noop,
  shouldCloseTakeover: false,
  setShouldCloseTakeover: noop,
});

export const useInStudioTakeoverContext = () => useContext(InStudioTakeoverContext);
